<div class="container walletConnectDialog">
    <div class="row">
        <div class="col-sm">
            <nb-card>
                <nb-card-body>
                    <div class="row text-center">
                        <div class="col">
                            <h3>You must be invited to access this page.</h3>
                        </div>
                    </div>
                    <div class="row text-center">
                        <div class="col">
                            <h3 class='pt-3'>
                                If you have been Invited, please check your e-mail and enter the code you've received below.
                            </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <form action='' class='collectionsForm'>
                                <h3 class='text-center pt-3'>Code</h3>
                                <input [(ngModel)]='code' type='text' nbInput fullWidth="" name='code'>
                            </form>
                        </div>
                    </div>
                </nb-card-body>
                <div class="d-flex justify-content-center mt-3">
                    <button class='btn btnMiddle' nbButton status='primary' (click)='validateCode()'>Validate</button>
                </div>               
            </nb-card>
        </div>
    </div>
</div>